module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "page"
  }, [_c('hero', {
    attrs: {
      "extra": _vm.extra,
      "comments": _vm.extra.comments.length
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "postContent"
  }, [_c('div', {
    staticClass: "container",
    domProps: {
      "innerHTML": _vm._s(_vm.extraContent)
    }
  }), _vm._v(" "), (_vm.extra.tags) ? _c('div', {
    staticClass: "container tags"
  }, [_c('p', [_c('strong', [_vm._v("Tags:")]), _vm._v(" "), _vm._l((_vm.extra.tags), function(tag, index) {
    return _c('span', [_c('a', {
      attrs: {
        "href": '/tag/' + tag.slug
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(tag.name)
      }
    })]), _vm._v(" "), ((index + 1) < _vm.extra.tags.length) ? _c('span', [_vm._v(", ")]) : _vm._e()])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "postContent commentsContent"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('comments', {
    attrs: {
      "comments": _vm.extra.comments,
      "postId": _vm.extra.id
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65ba5d28"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Extra.vue
// module id = 787
// module chunks = 1